import Account from './Account';
import Anue from './Anue';
import Buy from './Buy/Buy';
import News from './News';
import Stock from './Stock';
import Tag from './Tag';

export { Account, Anue, Buy, News, Stock, Tag };
export default { Anue, Tag, News, Stock, Account, Buy };
